import React, { useState, useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

import logo from './logo.svg';



function GraficaRadar(props) {
    var cat = -1;
    var value = 10;

    const rootRef = useRef(null);
    const yAxisRef = useRef(null);
    const xAxisRef = useRef(null);
    const chartRef = useRef(null);

    // This code will only run one time
    useEffect(() => {
        let root = am5.Root.new("chartdiv");

        root.setThemes([am5themes_Animated.new(root),
        //am5themes_Dark.new(root),
        am5themes_Responsive.new(root)
        ]);

        var chart = root.container.children.push(
            am5radar.RadarChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "panX",
                wheelY: "zoomX"
            }));

        var cursor = chart.set("cursor", am5radar.RadarCursor.new(root, {
            behavior: "zoomX"
        }));

        cursor.lineY.set("visible", false);

        var xRenderer = am5radar.AxisRendererCircular.new(root, {});
        xRenderer.labels.template.setAll({
            radius: 10
        });

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            maxDeviation: 0,
            categoryField: "category",
            renderer: xRenderer,
            //tooltip: am5.Tooltip.new(root, {pointerOrientation: "up"})
        }));

        xRenderer.grid.template.setAll({
            location: 0.5,
            multiLocation: 0
        });

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: am5radar.AxisRendererRadial.new(root, {}),
            min: 0,
            max: 1,
            visible: false
        }));

        // Add scrollbars
        chart.set("scrollbarX", am5.Scrollbar.new(root, { orientation: "horizontal" }));
        chart.set("scrollbarY", am5.Scrollbar.new(root, { orientation: "vertical" }));

        // Animate chart
        // https://www.amcharts.com/docs/v5/concepts/animations/#Initial_animation
        chart.appear(1000, 100);

        xAxisRef.current = xAxis;
        yAxisRef.current = yAxis;
        rootRef.current = root;
        chartRef.current = chart;

        return () => {
            root.dispose();
        };

    }, []);

    // This code will only run when props.data changes
    useEffect(() => {
        /*
        let newData = []
        props.data.data.forEach(element => {
            let newElements = []
            props.data.axes.forEach(axis => {
                newElements.push({ category: axis.id + ". " + axis.vari.name + " " + axis.year, value: element[axis.vari.value], ...element })
            });
            newData.push(newElements)
        });
        console.log(newData)

        // Create unique categories
        xAxisRef.current.data.setAll(props.data.axes.map(axis => {
            return { category: axis.id + ". " + axis.vari.name + " " + axis.year }
        }));
        */

        let newData = []
        props.data.seriesIndividuales.forEach(item => {
            if (item.data.length > 0) {
                newData.push(item.data)
            }
        })

        xAxisRef.current.data.setAll(props.data.ejes);

        props.data.seriesGrupales.forEach(item => {
            Object.values(item.data).forEach(series => {
                if (series.length > 0) {
                    newData.push(series)
                }
            })
        })

        // Clear old series
        let size = chartRef.current.series.length.valueOf()
        for (let index = 0; index < size; index++) {
            chartRef.current.series.removeIndex(0).dispose();
        }

        newData.forEach(element => {

            let tooltipText = " "
            element.forEach(e => {
                tooltipText += e.tooltipText
            })

            var series = chartRef.current.series.push(am5radar.RadarLineSeries.new(rootRef.current, {
                stacked: false,
                name: element[0].municipality,
                xAxis: xAxisRef.current,
                yAxis: yAxisRef.current,
                valueYField: "value",
                categoryXField: "category",
                stroke: am5.color(element[0].color),
                fill: am5.color(element[0].color),
                //tooltip: am5.Tooltip.new(rootRef.current, {labelText: "{name}"+tooltipText})
            }));




            var tooltip = am5.Tooltip.new(rootRef.current, {
                getFillFromSprite: false,
                getStrokeFromSprite: true,
                autoTextColor: true,
                getLabelFillFromSprite: true,
                labelText: element[0].municipality + tooltipText,
                pointerOrientation: "horizontal",
            });

            tooltip.get("background").setAll({
                fill: am5.color(0xffffff),
                fillOpacity: 0.8
            });



            series.bullets.push(function () {

                var circle = am5.Circle.new(rootRef.current, {
                    radius: 2.5,
                    interactive: true, //required to trigger the state on hover
                    fill: series.get("fill")
                });

                circle.states.create('hover', {
                    scale: 2,
                });

                circle.set("tooltipText", element[0].municipality + tooltipText)


                let bullet = am5.Bullet.new(rootRef.current, {
                    sprite: circle
                });

                return bullet

            });

            series.fills.template.setAll({
                visible: true,
                fillOpacity: 0.5,
            });

            series.data.setAll(element);
            series.set("tooltip", tooltip);
            series.appear(1000);
        })


    }, [props]);


    return <div id="chartdiv" style={{ width: "100%", height: "calc(100vh - 170px)" }}></div>;
}

export default GraficaRadar;